import { combineReducers } from 'redux';
import menuReducer from './menuReducer';

const rootReducer = combineReducers({
  menu: menuReducer,
  // Otros reducers pueden ir aquí
});

export default rootReducer;